export const initMobileMenu = () => {
  const html = document.documentElement;
  const burgerBtn = document.querySelector('.burger-btn');
  const mobileMenuContainer = document.querySelector('.mobile-menu-container');
  const submenuItems = document.querySelectorAll('.mobile-nav-submenu-item');
  const header = document.querySelector('.header');

  const closeActiveSubMenu = () => {
    submenuItems.forEach((item) => {
      item.classList.remove('active');
      item.querySelector('.mobile-nav-submenu').style.height = '0px';
    });
  };

  const openMobileMenu = () => {
    html.classList.add('lock-scroll');
    mobileMenuContainer.classList.add('menu-open');
    header.classList.add('header--announcment-bar-hide');
  };

  const closeMobileMenu = () => {
    mobileMenuContainer.classList.add('menu-hide-anim');
    html.classList.remove('lock-scroll');
    header.classList.remove('header--announcment-bar-hide');

    setTimeout(() => {
      mobileMenuContainer.classList.remove('menu-open');
      mobileMenuContainer.classList.remove('menu-hide-anim');
      closeActiveSubMenu();
    }, 250);
  };

  burgerBtn.addEventListener('click', openMobileMenu);
  mobileMenuContainer.addEventListener('click', (e) => {
    const elem = e.target;

    if (elem.closest('.mobile-menu__close-btn') || elem.closest('.mobile-menu-overlay')) {
      closeMobileMenu();
    }
  });
};

export const initMobileSubmenus = () => {
  const submenuItems = document.querySelectorAll('.mobile-nav-submenu-item__button');

  if (!submenuItems.length) {
    return;
  }

  const clickHandler = (btn) => {
    const submenu = btn.parentElement;
    const submenuItems = submenu.querySelectorAll('.mobile-nav-submenu__item');
    const submenuItemsList = submenu.querySelector('.mobile-nav-submenu');

    if (submenu.classList.contains('active')) {
      submenu.classList.remove('active');
      submenuItemsList.style.height = '0px';
    } else {
      submenu.classList.add('active');

      const submenuHeight = Array.from(submenuItems).reduce(
        (accumulator, currentValue) => accumulator + currentValue.offsetHeight,
        0
      );
      submenuItemsList.style.height = `${submenuHeight}px`;
    }
  };

  submenuItems.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      if (e.target.tagName === 'A') {
        return;
      }

      clickHandler(btn);
    });
  });
};
